import React from "react"

type IconProps = {
    className?: string
    size?: number
}

export function YenIcon({ className, size = 14 }: IconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 25"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
        >
            <path d="M11.5233 9.42183L17.0036 1.27641C17.5286 0.488384 18.5893 0.275708 19.3821 0.800701C20.1696 1.32623 20.3785 2.39014 19.8535 3.17817L14.775 10.7504H17.5714C18.5196 10.7504 19.2857 11.5647 19.2857 12.4646C19.2857 13.4611 18.5196 14.1789 17.5714 14.1789H13.2858V15.8932H17.5714C18.5196 15.8932 19.2857 16.7074 19.2857 17.6556C19.2857 18.6038 18.5196 19.3699 17.5714 19.3699H13.2858V22.7984C13.2858 23.7466 12.5197 24.5127 11.5233 24.5127C10.6233 24.5127 9.80903 23.7466 9.80903 22.7984V19.3699H5.52338C4.625 19.3699 3.80912 18.6038 3.80912 17.6556C3.80912 16.7074 4.625 15.8932 5.52338 15.8932H9.80903V14.1789H5.52338C4.625 14.1789 3.80912 13.4611 3.80912 12.4646C3.80912 11.5647 4.625 10.7504 5.52338 10.7504H8.36798L3.28809 3.17817C2.76293 2.39014 2.97577 1.32623 3.76358 0.800701C4.55107 0.275708 5.61552 0.488384 6.14051 1.27641L11.5233 9.42183Z" />
        </svg>
    )
}

export function StarIcon({ className, size = 15 }: IconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 15 15"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
        >
            <path d="M10.0979 4.25117L14.1614 4.85065C14.4979 4.89872 14.7806 5.13625 14.8881 5.46143C14.9955 5.78945 14.9079 6.14574 14.6647 6.38893L11.7182 9.27886L12.4138 13.4243C12.4704 13.7636 12.3318 14.1086 12.0491 14.3094C11.7691 14.5101 11.3987 14.5356 11.0961 14.3744L7.46532 12.4374L3.83736 14.3744C3.53197 14.5356 3.16153 14.5101 2.88159 14.3094C2.60165 14.1086 2.46026 13.7636 2.51964 13.4243L3.21526 9.27886L0.268211 6.38893C0.024744 6.14574 -0.0617843 5.78945 0.0451035 5.46143C0.151709 5.13625 0.433632 4.89872 0.772676 4.85065L4.83272 4.25117L6.65377 0.509247C6.80364 0.197745 7.12034 0 7.46532 0C7.81313 0 8.12984 0.197745 8.27971 0.509247L10.0979 4.25117Z" />
        </svg>
    )
}

export function MapPinIcon({ className, size = 14 }: IconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
        >
            <path d="M10.9095 23.4607C8.45631 20.4435 3 13.1309 3 9.02335C3 4.03983 7.03983 0 12.0234 0C17.005 0 21.0467 4.03983 21.0467 9.02335C21.0467 13.1309 15.5481 20.4435 13.1372 23.4607C12.5591 24.1798 11.4876 24.1798 10.9095 23.4607ZM12.0234 12.0311C13.6823 12.0311 15.0311 10.6823 15.0311 9.02335C15.0311 7.36437 13.6823 6.01557 12.0234 6.01557C10.3644 6.01557 9.01557 7.36437 9.01557 9.02335C9.01557 10.6823 10.3644 12.0311 12.0234 12.0311Z" />
        </svg>
    )
}
